import React from 'react';
import { oneOf, string, node, object, bool } from 'prop-types';
import setClass from '../../common/set-class';
/*
 * flex by default will line them up next to each other
 * gapType will set the gap value
 * wrap will make them wrap
 */
const setFlexClass = ({ wrap, gapType, direction }) => {
    const gaps = {
        gap1: 'g1',
        gap2: 'g2',
        gap3: 'g3',
        'default-gap': 'g',
    };
    let klass = 'b-flex';
    if (wrap && direction === 'row') {
        klass += '-wrap';
    }
    if (gapType && direction === 'row') {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        klass += `-${gaps[gapType]}`;
    }
    else if (gapType && direction === 'col') {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        klass += `-v${gaps[gapType]}`;
    }
    return klass;
};
const Flex = (props) => {
    const { children, style, className, wrap, gapType, direction, align, justify, } = props;
    const klass = setClass([
        setFlexClass({ wrap, gapType, direction }),
        className,
    ]);
    const styles = { ...style };
    if (direction === 'col') {
        styles.flexDirection = 'column';
        styles.alignItems = align;
        styles.justifyContent = justify;
    }
    else {
        styles.flexDirection = 'row';
        if (wrap) {
            styles.alignContent = align;
            styles.alignItems = align;
            styles.justifyContent = justify;
        }
        else {
            styles.alignItems = align;
            styles.justifyContent = justify;
        }
    }
    return (React.createElement("div", { className: klass, style: styles }, children));
};
Flex.propTypes = {
    /** wraps children in a `div` with the appropriate class */
    children: node,
    /** `style` can also be passed in for overriding styles */
    style: object,
    /** extra classes can be passed in */
    className: string,
    /** only applies to flex row, will make items wrap */
    wrap: bool,
    /** sets the gap type */
    gapType: oneOf(['gap1', 'gap2', 'gap3', 'default-gap']),
    /** sets the flex direction */
    direction: oneOf(['row', 'col']),
    /** align, will apply depending on the direction */
    align: oneOf(['flex-start', 'center', 'flex-end']),
    /** justify, will apply depending on the direction */
    justify: oneOf([
        'flex-start',
        'center',
        'flex-end',
        'space-between',
        'space-around',
    ]),
};
Flex.defaultProps = {
    children: null,
    style: {},
    className: '',
    wrap: false,
    gapType: 'default-gap',
    direction: 'row',
    align: 'flex-start',
    justify: 'flex-start',
};
export default Flex;
